<template>
  <div class="row">
    <div class="col-lg-12 col-xxl-12">
      <div class="col-lg-11">
        <b-form @submit.stop.prevent="onSubmit">
          <b-row class="mb-8">
            <b-col sm="12" class="text-center">
              <ckeditor id="detail_th-input" name="detail_th-input" v-model="$v.form.detail.$model"
                :config="editorConfig">
              </ckeditor>

            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <b-button type="submit" variant="primary" class="float-right mr-3">{{
                  $t("PAGE.DEFAULT.FORM.BTN_SUBMIT")
              }}</b-button>
            </b-col>
          </b-row>
        </b-form>
      </div>
    </div>
  </div>
</template>
<style>
.imgSize {
  margin-left: 30%;
  padding-top: 0.5cm;
  width: 30%;
  height: 30%;
  padding-bottom: 0.5cm;
}
</style>
<script>
import { POST_MORE_DETAIL_INFO_DATA, PUT_MORE_DETAIL_INFO_DATA, GET_MORE_DETAIL_INFO_DATA, SET_STATE_PRAM_M_DETAIL_INFO } from "@/core/services/store/more_detail_info.module";

import Swal from "sweetalert2";
export default {
  components: {
  },

  data() {
    return {
      editorConfig: {
        extraPlugins: "emoji,image2",
        filebrowserUploadUrl: `${process.env.VUE_APP_API}/ckeditor_image_upload`
      },
      id: 0,
      form: {
        detail: ""
      },
    };
  },
  validations: {
    form: {
      detail: {},
    }
  },

  mounted() {
    this.mangrove_location_id = this.$route.params.id
    if (this.mangrove_location_id > 0) {
      this.get(this.mangrove_location_id);
    }
  },
  methods: {
    setdata(data) {
      this.$store.commit(SET_STATE_PRAM_M_DETAIL_INFO, { more_detail_info_id: data.id });
    },
    get(id) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch(GET_MORE_DETAIL_INFO_DATA, { id })
            .then(({ data }) => {
              Swal.close();
              if (data.status === "success" && data.data) {
                this.id=data.data.id
                for (const formKey of Object.keys(this.form)) {
                  for (const dataKey of Object.keys(data.data)) {
                    if (formKey === dataKey) {
                      this.form[formKey] = data.data[formKey];
                    }
                  }
                }
              } else if (data.status === "error" && data.error) {
                Swal.fire({
                  icon: "error",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
                });
              }
            })
            .catch(error => {
              Swal.close();
              Swal.fire({
                icon: "error",
                text: `${error}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
              });
            });
        }
      });
    },
    onSubmit() {
      let formData = new FormData();
      let id = this.id
      formData.append("mangrove_location_id",this.$store.state.mangrove_location.data_pram.mangrove_location_id );
      formData.append("detail", this.form.detail);
      if (this.id > 0) {
        this.update(id, formData)
      } else {
        this.create(formData);
      }

    },
    update(id, data) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch(PUT_MORE_DETAIL_INFO_DATA, { id, data })
            .then(({ data }) => {
              Swal.close();
              if (data.status === "success" && data.data) {
                this.setdata(data.data)
                Swal.fire({
                  icon: "success",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.data)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000'
                });

              } else if (data.status === "error" && data.error) {
                this.$v.$reset();
                Swal.fire({
                  icon: "error",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000'
                });
              }
            })
            .catch(error => {
              Swal.close();
              Swal.fire({
                icon: "error",
                text: `${error}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                confirmButtonColor: '#840000'
              });
            });
        }
      });
    },

    create(data) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch(POST_MORE_DETAIL_INFO_DATA, { data })
            .then(({ data }) => {
              Swal.close();
              if (data.status === "success" && data.data) {
                this.mangrove_location_id = data.data.mangrove_location_id
                this.id = data.data.id
                this.setdata(data.data)
                Swal.fire({
                  icon: "success",
                  text: `${this.$t("RESPONSE_MESSAGE.SUCCESS_TO_SAVE_DATA")}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000'
                });

              } else if (data.status === "error" && data.error) {
                this.$v.$reset();
                Swal.fire({
                  icon: "error",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000'
                });
              }
            })
            .catch(error => {
              Swal.close();
              Swal.fire({
                icon: "error",
                text: `${error}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                confirmButtonColor: '#840000'
              });
            });
        }
      });
    },

    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
  }
};
</script>
